import React from 'react';
import Grid from '../../components/grid/grid';
import Footer from '../footer/footer';

const Container = () => {
  return (
    <div>
      <Grid />
      <Footer />
    </div>
  );
};

export default Container;
